// hooks/useGhsxSocket.js

import { useCallback, useEffect } from "react";

/* ======================================================
   GHSX SOCKET HOOK
====================================================== */

export default function useGhsxSocket(
  socket,
  {
    onTransferSuccess,
    onReceived,
    onTransferError,
  } = {}
) {

  /* =========================================
     SEND GHSX
  ========================================= */

  const transferGhsx =
    useCallback(
      ({
        recipientAddress,
        amount,
      }) => {

        if (!socket) return;

        socket.emit(
          "ghsx-transfer",
          {
            recipientAddress,
            amount,
          }
        );

      },
      [socket]
    );

  /* =========================================
     LISTENERS
  ========================================= */

  useEffect(() => {

    if (!socket) return;

    const handleSuccess =
      (payload) => {
        onTransferSuccess?.(payload);
      };

    const handleReceived =
      (payload) => {
        onReceived?.(payload);
      };

    const handleError =
      (payload) => {
        onTransferError?.(payload);
      };

    socket.on(
      "ghsx-transfer-success",
      handleSuccess
    );

    socket.on(
      "ghsx-received",
      handleReceived
    );

    socket.on(
      "ghsx-transfer-error",
      handleError
    );

    return () => {

      socket.off(
        "ghsx-transfer-success",
        handleSuccess
      );

      socket.off(
        "ghsx-received",
        handleReceived
      );

      socket.off(
        "ghsx-transfer-error",
        handleError
      );

    };

  }, [
    socket,
    onTransferSuccess,
    onReceived,
    onTransferError,
  ]);

  return {
    transferGhsx,
  };

}